module.exports = __webpack_public_path__ + "media/images/menu-f1c7610f5913ddf6350dff8876859a55.svg";